import React, { FC, useEffect, useRef } from 'react';

import ReactSelect, {
  components,
  OptionProps,
  SingleValueProps,
  ActionMeta,
  MultiValue, DropdownIndicatorProps, IndicatorSeparatorProps, IndicatorsContainerProps, GroupBase,
} from 'react-select';

import classNames from 'classnames';
import MenuItem from '@material-ui/core/MenuItem';
import style from './style.module.css';
import { ISimpleSelectProps, ListItem } from './types';
import { getReactSelectStyles } from './style-helper';
import typ from 'design-v2/globals/typography.module.css';
import PreventDoubleClickToZoom from 'design-v2/common/PreventDoubleClickToZoom/index';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const NS = 'SimpleSelect';

const SimpleSelect: FC<ISimpleSelectProps> = ({
  label,
  list,
  handleSelectItem,
  selectedItemIndex,
  centerList,
  focusValue,
  isDisable,
  isFloorPlanDesign,
  alternateSelectionHighlight,
  largeFont
}) => {
  if (!list || !list.length) {
    return null;
  }

  const useStyles = makeStyles({
    singleSelectedValueText: {
      color: `${isFloorPlanDesign ? '#fff !important' : '#666 !important'}`,
    },
  });

  const classes = useStyles();

  const selectInputRef = useRef();

  const selectSingleTable = (itemIndex: number) => {
    if (itemIndex >= list.length || itemIndex < 0) {
      console.warn(
        NS,
        `selectSingleTable error on ${label} - index out of range ${itemIndex}/${list.length}`,
        list
      );
      return;
    }

    const item = list[itemIndex];
    (selectInputRef.current as OptionProps<ListItem>).setValue([item], 'select-option');
  };
  const getReadOnlyValue = (): Readonly<ListItem[]> => {
    return (selectInputRef.current as OptionProps<ListItem>).getValue();
  };

  useEffect(() => {
    if (list.length && selectedItemIndex > -1) {
      const currentValue = getReadOnlyValue();
      if (currentValue?.length && currentValue[0].value === list[selectedItemIndex].value) {
        // no use setting if same value
        return;
      }
      selectSingleTable(selectedItemIndex);
    }
  }, [selectedItemIndex, list]);

  const Option = (props: OptionProps<ListItem>) => {
    // OptionProps<ITableDividerHeader>

    return (
      <div id={`${props.data.value}`} ref={props.innerRef}>
        <components.Option {...props}>
          <PreventDoubleClickToZoom>
            <MenuItem
              disableRipple
              className={classNames({
                [typ.typMed]: true,
                [style.menuItemSelected]: !alternateSelectionHighlight && props.isSelected,
                [style.menuItemSelectedFp]: alternateSelectionHighlight && props.isSelected,
                [style.largeItemTextSize]: alternateSelectionHighlight
              })}
              value={props.data.value as any}
              style={props.data.style}
            >
              {props.data.name}
            </MenuItem>
          </PreventDoubleClickToZoom>
        </components.Option>
      </div>
    );
  };

  const SingleValue = ({ children, ...props }: SingleValueProps<ListItem>) => {
    let isNow = false;
    let singleText = props.data.selectedLabel ? props.data.selectedLabel : props.data.name;
    if (isFloorPlanDesign && props.selectProps.placeholder === 'Times') {
      isNow = (props.data.name as string).includes('Now');
      singleText = moment(props.data.value).format('LT')
    }
    return (
      <components.SingleValue {...props}>
        <div
          className={classNames({
            [style.singleSelectedValue]: true,
            [classes.singleSelectedValueText]: true,
            [style.largeItemTextSize]: largeFont
          })}>
          {singleText}
        </div>
      </components.SingleValue>
    );
  };

  return (
    <div className={classNames({
      [style.childContainerSelect]: true
    })}>
      <ReactSelect
        ref={selectInputRef}
        isDisabled={isDisable}
        options={list}
        placeholder={label}
        isSearchable={false}
        isClearable={false}
        hideSelectedOptions={false}
        closeMenuOnSelect={true}
        menuShouldScrollIntoView
        onMenuOpen={() => {
          if (selectedItemIndex === -1) return;
          setTimeout(() => {
            document.getElementById(`${focusValue}`)?.scrollIntoView();
          });
        }}
        // menuIsOpen={true} // useful for debugging

        // getOptionValue={(option: ListItem) => option.value as string}

        // changing 'value' prop causes the whole list to rerender, which leads to terrible performance
        // value={list[localSelectedIndex]}

        menuPortalTarget={document.body}
        components={{
          Option,
          SingleValue
        }}
        onChange={(newValue: ListItem | MultiValue<ListItem>, actionMeta: ActionMeta<ListItem>) => {
          const _selectedIndex: number = list.findIndex((item) => {
            const _newValue: ListItem = Array.isArray(newValue)
              ? (newValue as MultiValue<ListItem>)[0]
              : (newValue as ListItem);
            return item.value === _newValue.value;
          });
          handleSelectItem(_selectedIndex);
        }}
        styles={getReactSelectStyles(centerList, largeFont, isFloorPlanDesign)}
      />
    </div>

  );
};

export default SimpleSelect;
